import React from "react";
import TrashIcon from "icons/TrashIcon";

export default function DeleteButton({ handleTrashClick }) {
  return (
    <button
      onClick={handleTrashClick}
      className="trash-button"
      data-cy="trash-button"
    >
      <TrashIcon />
    </button>
  );
}
